export const LEGAL_BASIS_VALUES = ['consent', 'legitimate_interest', 'contract', 'other'];
export const LEGAL_BASIS_LABELS = {
    consent: 'Toestemming',
    legitimate_interest: 'Gerechtvaardigd belang',
    contract: 'Contract',
    other: 'Overig',
};
//# sourceMappingURL=legalBasis.js.map